module.exports = __webpack_public_path__ + "img/4f8fa0641720e2ea6570254c98a8eaf7.2e1951fb.jpg";